import { useState } from "react";
import AboutUsBottomSheet from "./Footerinfo/AboutUsBottomSheet";
import ContactUsBottomSheet from "./Footerinfo/ContactUsBottomSheet";
import PrivacyPolicyBottomSheet from "./Footerinfo/PrivacyPolicyBottomSheet";
import ReturnsPolicyBottomSheet from "./Footerinfo/ReturnsPolicyBottomSheet";
import TermsConditionsBottomSheet from "./Footerinfo/TermsConditionsBottomSheet";
import DeliveryPolicyBottomSheet from "./Footerinfo/DeliveryPolicyBottomSheet";
import CancellationPolicyBottomSheet from "./Footerinfo/CancellationPolicyBottomSheet";
import DeliveryInfoBottomSheet from "./Footerinfo/DeliveryInfoBottomSheet";
import BlogsBottomSheet from "./Footerinfo/BlogsBottomSheet";
import CookiePolicyBottomSheet from "./Footerinfo/CookiePolicyBottomSheet";

const GroceryFooter = () => {
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isReturnsOpen, setIsReturnsOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isDeliveryOpen, setIsDeliveryOpen] = useState(false);
  const [isCancellationOpen, setIsCancellationOpen] = useState(false);
  const [isDeliveryInfoOpen, setIsDeliveryInfoOpen] = useState(false);
  const [isBlogsOpen, setIsBlogsOpen] = useState(false);
  const [isCookiePolicyOpen, setIsCookiePolicyOpen] = useState(false);
  return (
    <>
      <footer style={styles.footer}>
        <div style={styles.container} className="footer-container">

        {/* Left Section - Contact & Social */}
        <div style={styles.section} className="footer-section footer-contact-section">
          <div style={styles.emailRow}>
            <span style={styles.emailIcon}>✉</span>
            <div>
              <p style={styles.label}>Email</p>
              <a href="arrohfood@gmail.com" style={styles.emailLink}>
                arrohfood@gmail.com
              </a>
            </div>
          </div>

          <p style={styles.label}>Follow Us</p>
          <div style={styles.socialRow}>
            <a href="#/" style={styles.socialIcon}>
              <img
                src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/facebook.svg"
                alt="Facebook"
                style={styles.socialImg}
              />
            </a>
            <a href="#/" style={styles.socialIcon}>
              <img
                src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/instagram.svg"
                alt="Instagram"
                style={styles.socialImg}
              />
            </a>
            <a href="#/" style={styles.socialIcon}>
              <img
                src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/youtube.svg"
                alt="YouTube"
                style={styles.socialImg}
              />
            </a>
          </div>

          <p style={styles.label}>Download App</p>
          <div style={styles.appButtonsRow}>
            <a href="#/">
              <img
                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                alt="Download on the App Store"
                style={styles.storeBadge}
              />
            </a>
            <a href="#/">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
                style={styles.storeBadge}
              />
            </a>
          </div>
        </div>

        {/* Middle Left - Navigation */}
        <div style={styles.section} className="footer-section footer-links-section">
          {["Shop", "About Us", "Blogs", "Request a call back", "Privacy Policy", "Returns Policy"].map((item) => (
            <a 
              key={item} 
              href="#/" 
              style={styles.navLink}
              onClick={(e) => {
                if (item === "About Us") {
                  e.preventDefault();
                  setIsAboutOpen(true);
                } else if (item === "Privacy Policy") {
                  e.preventDefault();
                  setIsPrivacyOpen(true);
                } else if (item === "Returns Policy") {
                  e.preventDefault();
                  setIsReturnsOpen(true);
                } else if (item === "Blogs") {
                  e.preventDefault();
                  setIsBlogsOpen(true);
                }
              }}
            >
              {item}
            </a>
          ))}
        </div>

        {/* Middle Right - Policies */}
        <div style={styles.section} className="footer-section footer-links-section">
          {["Terms & Conditions", "Delivery Policy", "Cancellation Policy", "Delivery Info", "Cookie Policy", "Contact Us"].map((item) => (
            <a 
              key={item} 
              href="#/" 
              style={styles.navLink}
              onClick={(e) => {
                if (item === "Contact Us") {
                  e.preventDefault();
                  setIsContactOpen(true);
                } else if (item === "Terms & Conditions") {
                  e.preventDefault();
                  setIsTermsOpen(true);
                } else if (item === "Delivery Policy") {
                  e.preventDefault();
                  setIsDeliveryOpen(true);
                } else if (item === "Cancellation Policy") {
                  e.preventDefault();
                  setIsCancellationOpen(true);
                } else if (item === "Delivery Info") {
                  e.preventDefault();
                  setIsDeliveryInfoOpen(true);
                } else if (item === "Cookie Policy") {
                  e.preventDefault();
                  setIsCookiePolicyOpen(true);
                }
              }}
            >
              {item}
            </a>
          ))}
        </div>

        {/* Right Section - Company Info */}
        <div style={styles.section} className="footer-section footer-company-section">
          <p style={styles.companyName}>Grocery Store Limited</p>
          <p style={styles.addressLabel}>
Our Store :</p>
          <p style={styles.addressText}>
           42 Town Centre, Hatfield ,<br />
         
Near Post Office ,<br />
           Hertfordshire, AL10 0JT <br />
            Phone no : 01707 269944 
          </p>
        </div>

      </div>

      {/* Payment Methods Bar */}
      <div style={styles.paymentBar}>
        <div style={styles.paymentIcons}>

          <span style={styles.paymentBadge}>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/f/f2/Google_Pay_Logo.svg"
              alt="Google Pay"
              style={styles.paymentImg}
            />
          </span>

          <span style={styles.paymentBadge}>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/b/b0/Apple_Pay_logo.svg"
              alt="Apple Pay"
              style={styles.paymentImg}
            />
          </span>

          <span style={styles.paymentBadge}>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/4/40/JCB_logo.svg"
              alt="JCB"
              style={styles.paymentImg}
            />
          </span>

          <span style={styles.paymentBadge}>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/8/80/Maestro_2016.svg"
              alt="Maestro"
              style={styles.paymentImg}
            />
          </span>

          <span style={styles.paymentBadge}>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/5/5c/Visa_Inc._logo_%282021%E2%80%93present%29.svg"
              alt="Visa"
              style={styles.paymentImg}
            />
          </span>

        </div>
      </div>
    </footer>
      <AboutUsBottomSheet isOpen={isAboutOpen} onClose={() => setIsAboutOpen(false)} />
      <ContactUsBottomSheet isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} />
      <PrivacyPolicyBottomSheet isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} />
      <ReturnsPolicyBottomSheet isOpen={isReturnsOpen} onClose={() => setIsReturnsOpen(false)} />
      <TermsConditionsBottomSheet isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} />
      <DeliveryPolicyBottomSheet isOpen={isDeliveryOpen} onClose={() => setIsDeliveryOpen(false)} />
      <CancellationPolicyBottomSheet isOpen={isCancellationOpen} onClose={() => setIsCancellationOpen(false)} />
      <DeliveryInfoBottomSheet isOpen={isDeliveryInfoOpen} onClose={() => setIsDeliveryInfoOpen(false)} />
      <BlogsBottomSheet isOpen={isBlogsOpen} onClose={() => setIsBlogsOpen(false)} />
      <CookiePolicyBottomSheet isOpen={isCookiePolicyOpen} onClose={() => setIsCookiePolicyOpen(false)} />
    </>
  );
};

const styles = {
  footer: {
    backgroundColor: "#f9f9f9",
    borderTop: "1px solid #e0e0e0",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    color: "#333",
    paddingTop: "40px",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 10px 30px",
    display: "flex",
    flexWrap: "wrap",
    gap: "15px",
    justifyContent: "space-between",
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    minWidth: "140px",
    flex: "1 1 140px",
  },
  label: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#333",
    margin: "8px 0 4px",
  },
  emailRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    marginBottom: "8px",
  },
  emailIcon: {
    fontSize: "22px",
    color: "#555",
    marginTop: "2px",
  },
  emailLink: {
    color: "#e05c2a",
    textDecoration: "none",
    fontSize: "14px",
    fontWeight: "500",
  },
  socialRow: {
    display: "flex",
    gap: "10px",
    marginBottom: "10px",
  },
  socialIcon: {
    width: "34px",
    height: "34px",
    borderRadius: "50%",
    border: "1px solid #ccc",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    cursor: "pointer",
    padding: "7px",
    boxSizing: "border-box",
  },
  socialImg: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  appButtonsRow: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    marginTop: "4px",
  },
  storeBadge: {
    height: "40px",
    width: "auto",
    display: "block",
  },
  navLink: {
    textDecoration: "none",
    color: "#333",
    fontSize: "14px",
    lineHeight: "1.8",
    cursor: "pointer",
  },
  companyName: {
    fontWeight: "700",
    fontSize: "15px",
    color: "#111",
    marginBottom: "6px",
  },
  addressLabel: {
    fontSize: "13px",
    color: "#555",
    marginBottom: "4px",
  },
  addressText: {
    fontSize: "13px",
    color: "#555",
    lineHeight: "1.8",
  },
  paymentBar: {
    backgroundColor: "#2b2b5e",
    padding: "14px 20px",
    display: "flex",
    justifyContent: "flex-end",
  },
  paymentIcons: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    flexWrap: "wrap",
    maxWidth: "1200px",
    width: "100%",
    justifyContent: "flex-end",
  },
  paymentBadge: {
    backgroundColor: "#fff",
    padding: "6px 10px",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "36px",
    boxSizing: "border-box",
  },
  paymentImg: {
    height: "22px",
    width: "auto",
    objectFit: "contain",
  },
};

export default GroceryFooter;